import { useEffect, type RefObject } from 'react'
import { isSidebarScrolledStore } from '@/components/Law/Clause/scroll-store'
import { useScroll } from 'framer-motion'

/**
 * Sets `isSidebarScrolledStore` to true when the sidebar is scrolled
 */
export function useSidebarScroll (ref: RefObject<HTMLDivElement | null>): void {
  const { scrollY } = useScroll({ container: ref })
  useEffect(() => {
    return scrollY.on('change', (scrollPx) => {
      if (scrollPx > 5) {
        isSidebarScrolledStore.set(true)
      } else {
        isSidebarScrolledStore.set(false)
      }
    })
  }, [scrollY])
}
